import { apiV1 } from './api';

export const getCountries = (search = '') =>
  apiV1.get('static/countries/list', { params: { q: search } });

export const getCities = (search = '', country = 'uk') =>
  apiV1.get('static/cities/list', {
    params: {
      q: search,
      countryIds: country,
    },
  });

export const getCity = cityId => apiV1.get(`static/cities/${cityId}`);
